import { COU_httpPost } from '@/utils/http'

// 登录
async function Login(data) {
  const url = '/auth/loginByPwd/2021004123671377'
  const r = await COU_httpPost({ url, data })
  let msg = '', success = false, result = {}
  try {
    success = r.success
    msg = r.msg
    result = r.result
  }
  catch(error) {
    console.log(error)
  }
  result = result || {}
  return { result, success, msg }
}

export default {
  Login
}